export const TEXT = {
    UPLOADED: 'Uploaded'
}